import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Mapper } from 'tiime-expert-utils';

import { DocumentCategoryIdentifier } from '@enums/document-category-identifier.enum';
import { DocumentCategoryOwner } from '@enums/document-category-owner.enum';
import { DocumentCategory } from '@models/document-category';

@Component({
  selector: 'app-document-category-identifier-icon',
  templateUrl: './document-category-identifier-icon.component.html',
  styleUrls: ['./document-category-identifier-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentCategoryIdentifierIconComponent {
  @Input() documentCategory: DocumentCategory;

  readonly DocumentCategoryOwner = DocumentCategoryOwner;

  readonly mapToDocumentCategoryIdentifierIcon: Mapper<DocumentCategoryIdentifier, string> = (
    documentCategoryIdentifier: DocumentCategoryIdentifier,
    documentCategoryOwner: DocumentCategoryOwner
  ) => {
    if (documentCategoryOwner === DocumentCategoryOwner.accountant) {
      return 'assets/icon_other_document.svg';
    }

    switch (documentCategoryIdentifier) {
      case DocumentCategoryIdentifier.receipt:
        return 'assets/icon_receipt.svg';
      case DocumentCategoryIdentifier.expenseReport:
        return 'assets/icon_expense_report.svg';
      case DocumentCategoryIdentifier.annualAccount:
        return 'assets/icon_annual_account.svg';
      case DocumentCategoryIdentifier.advancedExpense:
        return 'assets/icon_advanced_expense.svg';
      case DocumentCategoryIdentifier.fiscal:
        return 'assets/icon_fiscal.svg';
      case DocumentCategoryIdentifier.externalInvoice:
        return 'assets/icon_external_invoice.svg';
      case DocumentCategoryIdentifier.juridical:
        return 'assets/icon_juridical.svg';
      case DocumentCategoryIdentifier.socialEmployee:
        return 'assets/icon_social_employee.svg';
      case DocumentCategoryIdentifier.socialDirector:
        return 'assets/icon_social_director.svg';
      case DocumentCategoryIdentifier.payslip:
        return 'assets/icon_payslip.svg';
      case DocumentCategoryIdentifier.permanentDocument:
        return 'assets/icon_permanent_document.svg';
      case DocumentCategoryIdentifier.mileageAllowance:
        return 'assets/icon_mileage_allowance.svg';
      case DocumentCategoryIdentifier.otherDocument:
      default:
        return 'assets/icon_other_document.svg';
    }
  };
}
